import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Printer } from "lucide-react";
import { FIRM, NAV_LINKS, PRACTICE_AREAS, IMAGES } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-navy-975 border-t border-white/10 text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src={IMAGES.logo}
              alt="Mahaney Law"
              className="logo-light h-16 md:h-24 w-auto"
            />
            <p className="mt-6 text-white/65 max-w-md leading-relaxed">
              Attorney Joseph M. Mahaney brings 40+ years of courtroom experience
              to clients across Massachusetts — in personal injury, motor vehicle
              accidents, truck accidents, slip and fall injuries, and criminal
              defense. {FIRM.serviceArea}.
            </p>
            <div className="mt-8 flex flex-col gap-3 text-sm text-white/80">
              <a
                href={`tel:${FIRM.phoneHref}`}
                data-testid="footer-phone"
                className="flex items-center gap-3 text-base font-semibold text-white hover:text-gold"
              >
                <Phone className="h-4 w-4 text-gold" /> {FIRM.phone}
              </a>
              <div className="flex items-center gap-3" data-testid="footer-fax">
                <Printer className="h-4 w-4 text-gold" /> Fax: {FIRM.fax}
              </div>
              <a
                href={`mailto:${FIRM.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 hover:text-white"
              >
                <Mail className="h-4 w-4 text-gold" /> {FIRM.email}
              </a>
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-gold mt-0.5" />
                <span>
                  {FIRM.address.line1}
                  <br />
                  {FIRM.address.line2}
                </span>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-gold">Navigate</div>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/70 hover:text-white text-sm link-underline"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow text-gold">Practice Areas</div>
            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6">
              {PRACTICE_AREAS.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={`/practice-areas/${p.slug}`}
                    data-testid={`footer-practice-${p.slug}`}
                    className="text-white/70 hover:text-white text-sm link-underline"
                  >
                    {p.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <p>© {year} Mahaney Law. All rights reserved.</p>
          <p className="max-w-2xl">
            Attorney advertising. Prior results do not guarantee a similar
            outcome. The information on this website is for general purposes only
            and does not constitute legal advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
